import PropTypes from 'prop-types';
import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withGreen800} from '@/hocs/withColors';
import Link from '@/links';
import ScrollingHandler from '@/scrollinghandler';
import {SectionPaddingHomeHero} from '@/section';
import {H1} from '@/typography';
import PictureWrapper from '@/ui/images-wrapper';
import partnerStyles from 'pages/partnership-program/partners.module.scss';

const prepareLink = ScrollingHandler.prepareOnClick;

const H1Green800 = withGreen800(H1);

const imgPath = '/static/images/partnership-program/inner-pages-hero/';

const propTypes = {
  title: PropTypes.string.isRequired
};

const responsiveImages = {
  desktopImageUrl: 'hero-bg-inner-pages',
  mobileImageUrl: 'hero-bg-inner-pages-mobile'
};

const InnerPartnerPagesHeroSection = ({title}) => (
  <div className={partnerStyles['image-overlay']}>
    <PictureWrapper
      imgPath={imgPath}
      responsiveImages={responsiveImages}
      altImage="About Workable Partners"
      className={partnerStyles['bg-img']}
      width={1208}
      height={686}
      fetchpriority="high"
      loading="eager"
    />
    <SectionPaddingHomeHero className={partnerStyles.content}>
      <Container variant="section-padding-below-nav">
        <Grid fluid>
          <Row center="xs">
            <Col xs={12} lg={9}>
              <H1Green800>{title}</H1Green800>
              <Link
                href="/partnership-program/apply"
                onClick={prepareLink('/partnership-program/apply')}
                variant="primary">
                Partner with us
              </Link>
            </Col>
          </Row>
        </Grid>
      </Container>
    </SectionPaddingHomeHero>
  </div>
);

InnerPartnerPagesHeroSection.propTypes = propTypes;

export default InnerPartnerPagesHeroSection;
